const removeRelationship = id => async (_, __, { api }) => {
  await api.factorCompany.deleteFactorCompanyRelationship(id);
};

export default removeRelationship;
